export function incomeRules(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  member: any,
  atribute: string,
  base: string
) {
  if (base === 'cadunico') {
    if (atribute === 'childLabor') {
      if (member?.workAndIncome[atribute].answer === true) return true
      return false
    }
    return false
  }
}

export function incomeAllMembersRules(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  family: any,
  atribute: string,
  base: string
) {
  if (base === 'agents') {
    const assistenceInfo = family.assistenceInfo
    let familyWithotAssistence = true
    Object.keys(family.assistenceInfo).forEach((assistenceInfoAtribute) => {
      if (
        assistenceInfo[assistenceInfoAtribute].answer !== undefined &&
        assistenceInfo[assistenceInfoAtribute].answer !== 'Não' &&
        assistenceInfo[assistenceInfoAtribute].answer !== 'não possui'
      )
        familyWithotAssistence = false
    })

    switch (atribute) {
      case 'sourceOfIncome':
        if (
          family?.workAndIncome[atribute].answer === undefined &&
          familyWithotAssistence
        )
          return true
        else return false
      case 'someoneWorks':
        if (
          family?.workAndIncome[atribute].answer === undefined ||
          family?.workAndIncome[atribute].answer === 'Não'
        )
          return true
        else return false
      default:
        return false
    }
  } else if (base === 'cadunico') {
    switch (atribute) {
      case 'totalExpense':
        if (
          family?.workAndIncome?.totalExpense.answer >
          family?.workAndIncome?.familyMeanCapital.answer
        )
          return true
        else return false
      case 'hasChildLabor':
        if (family?.hasChildLabor?.answer === true) return true
        else return false
      default:
        return false
    }
  }
}
